module.exports = __webpack_public_path__ + "img/2.4d6d0224.jpeg";